const CryptoJS = require('crypto-js');

function generateSignature({ path }) {
	const secretKey = process.env.VUE_APP_SECRET_KEY || '';
	const timestamp = Math.floor(Date.now() / 1000);
	const payloadString = `${timestamp}|${path}`;
	const hash = CryptoJS.HmacSHA256(payloadString, secretKey).toString(CryptoJS.enc.Hex);

	return {
		signature: hash,
		timestamp,
	};
}

export const interceptorRequest = (request) => {
	// ADD TOKEN
	if (!request.skipAuth) {
		const token = localStorage.getItem('token');
		if (!request.headers) {
			request.headers = {};
		}
		if (token) {
			request.headers.Authorization = `Bearer ${token}`;
		}
	}

	// ADD SIGNATURE
	const url = new URL(request.url, window.location.origin);
	const path = url.pathname; // e.g. /api/v1/products
	const trimmedPath = path.replace(/^\/+/, ''); // e.g. api/v1/products

	const { signature, timestamp } = generateSignature({ path: trimmedPath });

	return {
		...request,
		headers: {
			...request.headers,
			'X-Signature': signature,
			'X-Timestamp': timestamp,
		},
	};
};

export const interceptorRequestError = (error) => {
	return Promise.reject(error);
};
